import { DASH_LABELS, OLP, OCP, ORP } from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  [OLP]: {
    label: DASH_LABELS.OL_PANEL,
    partOverride: '42N_OL_Panel_Integrated_Storage',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  [OCP]: {
    label: DASH_LABELS.OC_PANEL,
    partOverride: '42N_OC_Panel_Overhead_Console',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  [ORP]: {
    label: DASH_LABELS.OR_PANEL,
    partOverride: '42N_OR_Panel',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: 'OVERHEAD_4E1_005_DAY',
  panels: [OLP, OCP, ORP],
  width: 5200,
  height: 300,
  panelsStyle: `
  `,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    [OLP]: {
      id: OLP,
      label: DASH_LABELS.OL_PANEL,
      hideAddMsf: true,
      isOverheadPocket: true,
      groups: {},
    },
    [OCP]: {
      id: OCP,
      label: DASH_LABELS.OC_PANEL,
      hideAddMsf: true,
      isOverheadPocket: true,
      groups: {},
    },
    [ORP]: {
      id: ORP,
      label: DASH_LABELS.OR_PANEL,
      groups: {
        ODR91: {
          order: 0,
          id: 'ODR91',
          panel: ORP,
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'Left MSF',
          detail: ['QQ'],
        },
        ODR92: {
          order: 1,
          id: 'ODR92',
          panel: ORP,
          label: 'Center MSF',
          isMsfOrMst: true,
          canDragGroup: true,
          detail: ['QQ'],
        },
        ODR93: {
          order: 2,
          id: 'ODR93',
          panel: ORP,
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'Right MSF',
          detail: ['QQ'],
        },
      },
    },
  },
}
